import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const TransactionHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
